import React from 'react';

// CR-136: the ONE shared post-verification success modal. Extracted verbatim
// (structure/style/icon/title/close button preserved) from Register.js's former
// inline popup — only the body paragraph changed to reflect that verification,
// not registration, is now the trigger. Register.js must never import/render this;
// OtpVerification.js is the sole renderer, shown only after verify success or the
// idempotent already-verified success path.
function SignupSuccessModal({ onClose }) {
  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex',
      alignItems: 'center', justifyContent: 'center', zIndex: 9999
    }}>
      <div style={{
        backgroundColor: '#fff', borderRadius: '12px', padding: '40px',
        maxWidth: '450px', width: '100%', textAlign: 'center', position: 'relative',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
      }}>
        <button onClick={onClose} style={{
          position: 'absolute', top: '15px', right: '15px', background: 'none',
          border: 'none', fontSize: '20px', cursor: 'pointer', color: '#666'
        }}>×</button>
        <div style={{
          width: '50px', height: '50px', borderRadius: '50%', backgroundColor: '#f0fdf4',
          display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px',
          color: '#1e3a8a', fontSize: '24px'
        }}>
          ✓
        </div>
        <p style={{ fontSize: '12px', fontWeight: 'bold', letterSpacing: '1px', color: '#1e3a8a', marginBottom: '10px', textTransform: 'uppercase' }}>
          WELCOME TO CLUSTROPS
        </p>
        <h2 style={{ fontSize: '24px', fontWeight: 'bold', margin: '0 0 20px 0', color: '#111827' }}>
          You're family now.
        </h2>
        <p style={{ fontSize: '14px', color: '#4b5563', lineHeight: '1.6', marginBottom: '30px' }}>
          Your email is verified and your account is under review. We'll email you once it's activated. Your ClustOps journey begins soon.
        </p>
        <p style={{ fontSize: '13px', fontWeight: '600', color: '#1e3a8a', marginBottom: '20px' }}>
          When you grow, we grow.
        </p>
        <button onClick={onClose} style={{
          width: '100%', padding: '12px', backgroundColor: '#1e3a8a', color: '#fff',
          border: 'none', borderRadius: '6px', fontSize: '16px', fontWeight: 'bold',
          cursor: 'pointer'
        }}>
          Got it, thanks!
        </button>
      </div>
    </div>
  );
}

export default SignupSuccessModal;
